import { zodResolver } from "@hookform/resolvers/zod";
import { t, Trans } from "@lingui/macro";
import { defaultProfile, profileSchema } from "@reactive-resume/schema";
import {
  Avatar,
  AvatarImage,
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
  Select,
  SelectItem,
  SelectContent,
  SelectTrigger,
  SelectValue,
} from "@reactive-resume/ui";
import { useForm } from "react-hook-form";
import { z } from "zod";

import { SectionDialog } from "../sections/shared/section-dialog";
import { URLInput } from "../sections/shared/url-input";
const formSchema = profileSchema;

type FormValues = z.infer<typeof formSchema>;
{
  /* <select name="social_links[key][]" class="form-control social_key" style="width: 20%;">
                                                                                 <option value="">Select Media Type</option>
                                                                                       <option value="linkedin">LinkedIn</option>
                                                                                       <option value="facebook">Facebook</option>
                                                                                       <option value="twitter">X (Twitter)</option>
                                                                                       <option value="koo">Koo</option>
                                                                                       <option value="medium">Medium</option>
                                                                                       <option value="instagram">Instagram</option>
                                                                                       <option value="tumblr">Tumblr</option>
                                                                                       <option value="behance">BeHance</option>
                                                                              </select> */
}
export const ProfilesDialog = () => {
  const form = useForm<FormValues>({
    defaultValues: defaultProfile,
    resolver: zodResolver(formSchema),
  });
  const products = [
    "Linkedin",
    "Facebook",
    "Twitter",
    "Koo",
    "Medium",
    "Instagram",
    "Tumblr",
    "Behance",
  ];

  const list: any = [];

  products.forEach((product) => {
    list.push(<SelectItem value={product}>{product}</SelectItem>);
  });
  return (
    <SectionDialog<FormValues> id="profiles" form={form} defaultValues={defaultProfile}>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <FormField
          name="network"
          control={form.control}
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t`Network`}</FormLabel>
              <FormControl>
                {/* eslint-disable-next-line lingui/no-unlocalized-strings */}
                {/* <Input {...field} placeholder="LinkedIn" /> */}
                <Select
                  {...field}
                  value={field.value}
                  onValueChange={(value) => {
                    form.setValue("network", value);
                    form.setValue("icon", value);
                    form.clearErrors();
                  }}
                >
                  <SelectTrigger>
                    <SelectValue placeholder={field.value || "Select Profile"} />
                  </SelectTrigger>
                  <SelectContent>{list}</SelectContent>{" "}
                </Select>
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          name="username"
          control={form.control}
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t`Username`}</FormLabel>
              <FormControl>
                <Input {...field} placeholder="john.doe" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          name="url"
          control={form.control}
          render={({ field }) => (
            <FormItem className="sm:col-span-2">
              <FormLabel>{t`Website`}</FormLabel>
              <FormControl>
                <URLInput {...field} placeholder="URL must start with https://" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          name="icon"
          control={form.control}
          render={({ field }) => (
            <FormItem className="sm:col-span-2">
              <FormLabel htmlFor="iconSlug">{t`Icon`}</FormLabel>
              <FormControl>
                <div className="flex items-center gap-x-2">
                  <Avatar className="size-8 bg-white">
                    {field.value && (
                      <AvatarImage
                        className="p-1.5"
                        src={`https://cdn-mybharat.dl6.in/mybharat//assets/img/mybharat/${field.value.toLowerCase()}.png`}
                      />
                    )}
                  </Avatar>
                  <Input {...field} id="iconSlug" placeholder="linkedin" />
                </div>
              </FormControl>
              <FormMessage />
              <FormDescription className="ml-10 powered-by-none">
                <Trans>
                  Powered by{" "}
                  <a
                    href="https://simpleicons.org/"
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className="font-medium"
                  >
                    Simple Icons
                  </a>
                </Trans>
              </FormDescription>
            </FormItem>
          )}
        />
      </div>
    </SectionDialog>
  );
};
